/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRangeFilter } from './DateRangeFilter';
import {
    DateRangeFilterFromJSON,
    DateRangeFilterFromJSONTyped,
    DateRangeFilterToJSON,
    DateRangeFilterToJSONTyped,
} from './DateRangeFilter';
import type { OrderByParams } from './OrderByParams';
import {
    OrderByParamsFromJSON,
    OrderByParamsFromJSONTyped,
    OrderByParamsToJSON,
    OrderByParamsToJSONTyped,
} from './OrderByParams';
import type { NumberRangeFilter } from './NumberRangeFilter';
import {
    NumberRangeFilterFromJSON,
    NumberRangeFilterFromJSONTyped,
    NumberRangeFilterToJSON,
    NumberRangeFilterToJSONTyped,
} from './NumberRangeFilter';
import type { FindListingsAv8RequestAreaFilter } from './FindListingsAv8RequestAreaFilter';
import {
    FindListingsAv8RequestAreaFilterFromJSON,
    FindListingsAv8RequestAreaFilterFromJSONTyped,
    FindListingsAv8RequestAreaFilterToJSON,
    FindListingsAv8RequestAreaFilterToJSONTyped,
} from './FindListingsAv8RequestAreaFilter';

/**
 * 
 * @export
 * @interface FindListingsAv8Request
 */
export interface FindListingsAv8Request {
    /**
     * 
     * @type {FindListingsAv8RequestAreaFilter}
     * @memberof FindListingsAv8Request
     */
    areaFilter?: FindListingsAv8RequestAreaFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    price?: NumberRangeFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindListingsAv8Request
     */
    propertyStatus?: Array<FindListingsAv8RequestPropertyStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindListingsAv8Request
     */
    propertyTypes?: Array<FindListingsAv8RequestPropertyTypesEnum>;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    bedroomsCount?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    bathroomsCount?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    livingSpaceSqFt?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    lotSizeSqFt?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    parkingGarageSpaces?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    homeownerAssociationFeeUSD?: NumberRangeFilter;
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof FindListingsAv8Request
     */
    soldDate?: DateRangeFilter;
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof FindListingsAv8Request
     */
    listDate?: DateRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof FindListingsAv8Request
     */
    propertyYearBuilt?: NumberRangeFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindListingsAv8Request
     */
    agentDreNumbers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FindListingsAv8Request
     */
    hasDoormanAttendance?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindListingsAv8Request
     */
    waterfrontClassification?: Array<FindListingsAv8RequestWaterfrontClassificationEnum>;
    /**
     * 
     * @type {OrderByParams}
     * @memberof FindListingsAv8Request
     */
    orderResultsBy?: OrderByParams;
    /**
     * 
     * @type {number}
     * @memberof FindListingsAv8Request
     */
    paginationPage?: number;
    /**
     * 
     * @type {number}
     * @memberof FindListingsAv8Request
     */
    paginationLimit?: number;
    /**
     * Detailed results include text description and all photos.
     * @type {boolean}
     * @memberof FindListingsAv8Request
     */
    detailedResults: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindListingsAv8Request
     */
    operationName: FindListingsAv8RequestOperationNameEnum;
}


/**
 * @export
 */
export const FindListingsAv8RequestPropertyStatusEnum = {
    Active: 'active',
    ActiveUnderContract: 'active-under-contract',
    ComingSoon: 'coming-soon',
    Contingent: 'contingent',
    Expired: 'expired',
    OffMarket: 'off-market',
    Pending: 'pending',
    Sold: 'sold',
    PendingBackupOfferRequested: 'pending-backup-offer-requested'
} as const;
export type FindListingsAv8RequestPropertyStatusEnum = typeof FindListingsAv8RequestPropertyStatusEnum[keyof typeof FindListingsAv8RequestPropertyStatusEnum];

/**
 * @export
 */
export const FindListingsAv8RequestPropertyTypesEnum = {
    Lease: 'Lease > *',
    LeaseCanonicalCommercial: 'Lease > CANONICAL > Commercial > *',
    LeaseCanonicalCommercialGeneral: 'Lease > CANONICAL > Commercial > General',
    LeaseCanonicalResidential: 'Lease > CANONICAL > Residential > *',
    LeaseCanonicalResidentialGeneral: 'Lease > CANONICAL > Residential > General',
    Sale: 'Sale > *',
    SaleCanonicalBusinessOpportunity: 'Sale > CANONICAL > Business Opportunity > ',
    SaleCanonicalBusinessOpportunity2: 'Sale > CANONICAL > Business Opportunity > *',
    SaleCanonicalCommercial: 'Sale > CANONICAL > Commercial > *',
    SaleCanonicalCommercialGeneral: 'Sale > CANONICAL > Commercial > General',
    SaleCanonicalLand: 'Sale > CANONICAL > Land > *',
    SaleCanonicalLandFarm: 'Sale > CANONICAL > Land > Farm',
    SaleCanonicalLandGeneral: 'Sale > CANONICAL > Land > General',
    SaleCanonicalResidential: 'Sale > CANONICAL > Residential > *',
    SaleCanonicalResidentialCondominium: 'Sale > CANONICAL > Residential > Condominium',
    SaleCanonicalResidentialCoOwnership: 'Sale > CANONICAL > Residential > Co-Ownership',
    SaleCanonicalResidentialIncome: 'Sale > CANONICAL > Residential Income > *',
    SaleCanonicalResidentialIncomeGeneral: 'Sale > CANONICAL > Residential Income > General',
    SaleCanonicalResidentialManufactured: 'Sale > CANONICAL > Residential > Manufactured',
    SaleCanonicalResidentialSingleFamilyResidence: 'Sale > CANONICAL > Residential > Single Family Residence'
} as const;
export type FindListingsAv8RequestPropertyTypesEnum = typeof FindListingsAv8RequestPropertyTypesEnum[keyof typeof FindListingsAv8RequestPropertyTypesEnum];

/**
 * @export
 */
export const FindListingsAv8RequestWaterfrontClassificationEnum = {
    Waterfront: 'waterfront',
    NearWater: 'near_water'
} as const;
export type FindListingsAv8RequestWaterfrontClassificationEnum = typeof FindListingsAv8RequestWaterfrontClassificationEnum[keyof typeof FindListingsAv8RequestWaterfrontClassificationEnum];

/**
 * @export
 */
export const FindListingsAv8RequestOperationNameEnum = {
    FindListingsV3: 'FindListingsV3'
} as const;
export type FindListingsAv8RequestOperationNameEnum = typeof FindListingsAv8RequestOperationNameEnum[keyof typeof FindListingsAv8RequestOperationNameEnum];


/**
 * Check if a given object implements the FindListingsAv8Request interface.
 */
export function instanceOfFindListingsAv8Request(value: object): value is FindListingsAv8Request {
    if (!('detailedResults' in value) || value['detailedResults'] === undefined) return false;
    if (!('operationName' in value) || value['operationName'] === undefined) return false;
    return true;
}

export function FindListingsAv8RequestFromJSON(json: any): FindListingsAv8Request {
    return FindListingsAv8RequestFromJSONTyped(json, false);
}

export function FindListingsAv8RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindListingsAv8Request {
    if (json == null) {
        return json;
    }
    return {
        
        'areaFilter': json['areaFilter'] == null ? undefined : FindListingsAv8RequestAreaFilterFromJSON(json['areaFilter']),
        'price': json['price'] == null ? undefined : NumberRangeFilterFromJSON(json['price']),
        'propertyStatus': json['propertyStatus'] == null ? undefined : json['propertyStatus'],
        'propertyTypes': json['propertyTypes'] == null ? undefined : json['propertyTypes'],
        'bedroomsCount': json['bedroomsCount'] == null ? undefined : NumberRangeFilterFromJSON(json['bedroomsCount']),
        'bathroomsCount': json['bathroomsCount'] == null ? undefined : NumberRangeFilterFromJSON(json['bathroomsCount']),
        'livingSpaceSqFt': json['livingSpaceSqFt'] == null ? undefined : NumberRangeFilterFromJSON(json['livingSpaceSqFt']),
        'lotSizeSqFt': json['lotSizeSqFt'] == null ? undefined : NumberRangeFilterFromJSON(json['lotSizeSqFt']),
        'parkingGarageSpaces': json['parkingGarageSpaces'] == null ? undefined : NumberRangeFilterFromJSON(json['parkingGarageSpaces']),
        'homeownerAssociationFeeUSD': json['homeownerAssociationFeeUSD'] == null ? undefined : NumberRangeFilterFromJSON(json['homeownerAssociationFeeUSD']),
        'soldDate': json['soldDate'] == null ? undefined : DateRangeFilterFromJSON(json['soldDate']),
        'listDate': json['listDate'] == null ? undefined : DateRangeFilterFromJSON(json['listDate']),
        'propertyYearBuilt': json['propertyYearBuilt'] == null ? undefined : NumberRangeFilterFromJSON(json['propertyYearBuilt']),
        'agentDreNumbers': json['agentDreNumbers'] == null ? undefined : json['agentDreNumbers'],
        'hasDoormanAttendance': json['hasDoormanAttendance'] == null ? undefined : json['hasDoormanAttendance'],
        'waterfrontClassification': json['waterfrontClassification'] == null ? undefined : json['waterfrontClassification'],
        'orderResultsBy': json['orderResultsBy'] == null ? undefined : OrderByParamsFromJSON(json['orderResultsBy']),
        'paginationPage': json['paginationPage'] == null ? undefined : json['paginationPage'],
        'paginationLimit': json['paginationLimit'] == null ? undefined : json['paginationLimit'],
        'detailedResults': json['detailedResults'],
        'operationName': json['operationName'],
    };
}

export function FindListingsAv8RequestToJSON(json: any): FindListingsAv8Request {
    return FindListingsAv8RequestToJSONTyped(json, false);
}

export function FindListingsAv8RequestToJSONTyped(value?: FindListingsAv8Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'areaFilter': FindListingsAv8RequestAreaFilterToJSON(value['areaFilter']),
        'price': NumberRangeFilterToJSON(value['price']),
        'propertyStatus': value['propertyStatus'],
        'propertyTypes': value['propertyTypes'],
        'bedroomsCount': NumberRangeFilterToJSON(value['bedroomsCount']),
        'bathroomsCount': NumberRangeFilterToJSON(value['bathroomsCount']),
        'livingSpaceSqFt': NumberRangeFilterToJSON(value['livingSpaceSqFt']),
        'lotSizeSqFt': NumberRangeFilterToJSON(value['lotSizeSqFt']),
        'parkingGarageSpaces': NumberRangeFilterToJSON(value['parkingGarageSpaces']),
        'homeownerAssociationFeeUSD': NumberRangeFilterToJSON(value['homeownerAssociationFeeUSD']),
        'soldDate': DateRangeFilterToJSON(value['soldDate']),
        'listDate': DateRangeFilterToJSON(value['listDate']),
        'propertyYearBuilt': NumberRangeFilterToJSON(value['propertyYearBuilt']),
        'agentDreNumbers': value['agentDreNumbers'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'waterfrontClassification': value['waterfrontClassification'],
        'orderResultsBy': OrderByParamsToJSON(value['orderResultsBy']),
        'paginationPage': value['paginationPage'],
        'paginationLimit': value['paginationLimit'],
        'detailedResults': value['detailedResults'],
        'operationName': value['operationName'],
    };
}

